(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6146],{

/***/ 97974:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var scrollToEl = function scrollToEl(e, checkHash) {
  var scrollToEl = document.getElementById(e.target.hash.replace("#", "")).getBoundingClientRect();
  window.scrollTo({
    top: scrollToEl.top + window.pageYOffset - 93,
    behavior: "smooth"
  });
  e.preventDefault();

  if (checkHash) {
    window.history.pushState(null, null, e.target.hash);
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (scrollToEl);

/***/ }),

/***/ 99954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var usePauseBrowserScroll = function usePauseBrowserScroll() {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (location.hash) {
      setTimeout(function () {
        var scrollToTable = document.getElementById(location.hash.replace("#", ""));

        if (scrollToTable) {
          window.scrollTo({
            top: scrollToTable.getBoundingClientRect().top + window.pageYOffset - 80,
            behavior: "smooth"
          });
        }
      }, 100);
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (usePauseBrowserScroll);

/***/ }),

/***/ 77450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SCREEN = {
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
  MOBILE: "MOBILE"
};

var useResizeScreenModified = function useResizeScreenModified(handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var _window3;

      var handleScreen = function handleScreen() {
        var _window;

        if ((_window = window) !== null && _window !== void 0 && _window.innerWidth) {
          var _window2;

          if (((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) <= 1023) {
            try {
              handler(SCREEN.TABLET);
            } catch (error) {
              console.error();
            }
          } else {
            try {
              handler(SCREEN.DESKTOP);
            } catch (error) {
              console.error();
            }
          }
        }
      };

      handleScreen();
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener("resize", handleScreen);
      return function () {
        var _window4;

        /* Clean up function. Remove event before component unmount. */
        (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.removeEventListener("resize", handleScreen);
      };
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useResizeScreenModified);

/***/ }),

/***/ 15068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GoToTop; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/io5/IoArrowUpOutline.js

function IoArrowUpOutline(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "48",
        "d": "M112 244l144-144 144 144M256 120v292"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/GoToTop/index.js



function GoToTop() {
  (0,react.useEffect)(function () {
    var calcScrollValue = function calcScrollValue() {
      var scrollProgress = document.getElementById("progress");
      var pos = document.documentElement.scrollTop;

      if (pos > 2000) {
        scrollProgress.style.opacity = 1;
        scrollProgress.style.pointerEvents = "auto";
      } else {
        scrollProgress.style.opacity = 0;
        scrollProgress.style.pointerEvents = "none";
      }

      scrollProgress.addEventListener("click", function (event) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        event.preventDefault();
      });
    };

    window.addEventListener("scroll", calcScrollValue, {
      passive: true
    });
    window.addEventListener("load", calcScrollValue, {
      passive: true
    });
    return function () {
      window.removeEventListener("scroll", calcScrollValue);
      window.removeEventListener("load", calcScrollValue);
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "progress",
    className: "fixed !z-[9999999999]",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      id: "progress-value",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IoArrowUpOutline, {
        size: 30
      })
    })
  });
}

/***/ }),

/***/ 23403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ FaFacebookF; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaFacebookF(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 320 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 19329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FaLinkedinIn; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaLinkedinIn(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 448 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 62353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FaTwitter; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaTwitter(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FiCalendar; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiCalendar(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 38626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





/** ========== */





var PostItem = function PostItem(_ref) {
  var _post$categories;

  var post = _ref.post,
      layout = _ref.layout;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  if (layout === "vertical") {
    var _post$featuredImage;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "flex h-full flex-1 flex-col rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833] xl:max-w-sm",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            as: "h3",
            className: "text-lg font-semibold text-bbc-brand-800 line-clamp-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "mt-4 line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-[5px] text-sm font-medium text-white",
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
              size: 18
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })]
    });
  }

  if (layout === "horizontal") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "text-bbc-brand-700",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          as: "h3",
          className: "text-lg font-medium line-clamp-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: post === null || post === void 0 ? void 0 : post.uri,
            children: post === null || post === void 0 ? void 0 : post.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mt-6 inline-flex items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
            size: 18
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: "inline-block pl-2 text-sm",
            children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {});
};

/* harmony default export */ __webpack_exports__["Z"] = (PostItem);
PostItem.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */

/***/ }),

/***/ 19347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SocialShare; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaFacebookF.js
var FaFacebookF = __webpack_require__(23403);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaLinkedinIn.js
var FaLinkedinIn = __webpack_require__(19329);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaTwitter.js
var FaTwitter = __webpack_require__(62353);
;// CONCATENATED MODULE: ./components/molecules/SocialShare/function.js
var handleOnFacebookShare = function handleOnFacebookShare(e) {
  e.preventDefault();
  var width = 650;
  var height = 450;
  var facebookWindow = window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(document.URL), "facebook-popup", "height=450,width=650", "top=".concat(screen.height / 2 - height / 2), "left=".concat(screen.width / 2 - width / 2), "menubar=no,toolbar=no,resizable=yes,scrollbars=yes");

  if (facebookWindow.focus) {
    facebookWindow.focus();
  }

  return false;
};
var handleOnTwitterShare = function handleOnTwitterShare() {
  var twitterWindow = window.open("https://twitter.com/share?url=".concat(document.URL), "twitter-popup", "height=350,width=600");

  if (twitterWindow.focus) {
    twitterWindow.focus();
  }

  return false;
};
var handleOnLinkedShare = function handleOnLinkedShare(e) {
  e.preventDefault();
  var LinkedinWindow = window.open("https://www.linkedin.com/sharer/sharer.php?u=".concat(document.URL), "linkedin-popup", "height=350,width=600");

  if (LinkedinWindow.focus) {
    LinkedinWindow.focus();
  }

  return false;
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/SocialShare/SocialShare.js







var listButton = [{
  icon: FaFacebookF/* FaFacebookF */.t,
  backgroundColor: "#1877f2",
  shareFunc: handleOnFacebookShare
}, {
  icon: FaTwitter/* FaTwitter */.f,
  backgroundColor: "#1da1f2",
  shareFunc: handleOnTwitterShare
}, {
  icon: FaLinkedinIn/* FaLinkedinIn */.B,
  backgroundColor: "#0077b5",
  shareFunc: handleOnLinkedShare
}];
function SocialShare(_ref) {
  var iconWidth = _ref.iconWidth,
      iconHeight = _ref.iconHeight,
      title = _ref.title,
      titleClass = _ref.titleClass,
      iconCLass = _ref.iconCLass;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "mb-4 block pt-2  ".concat(titleClass, " "),
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "social",
      className: "\n           sticky  flex items-end lg:items-start ".concat(iconCLass || ""),
      children: listButton.map(function (item, index) {
        var CustomTag = item.icon;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: item.shareFunc,
          style: {
            backgroundColor: item.backgroundColor,
            width: iconWidth,
            height: iconHeight
          },
          className: "mb-0 mr-2 rounded-full p-0 hover:brightness-110 lg:mb-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomTag, {
            width: 16,
            height: 16,
            color: "#fff",
            className: "m-auto"
          })
        }, index);
      })
    })]
  });
}

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 53807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AuthorAndTime; }
});

// EXTERNAL MODULE: ./common/functions.js
var functions = __webpack_require__(98989);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/fa/FaRegClock.js

function FaRegClock(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiCalendar.js
var FiCalendar = __webpack_require__(68840);
;// CONCATENATED MODULE: ./components/atoms/Icon/fi/FiUser.js

function FiUser(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "4"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/common/post/AuthorAndTime/index.js








var htmlparser = __webpack_require__(23719);

function AuthorAndTime(_ref) {
  var timeRead = _ref.timeRead,
      fullHead = _ref.fullHead,
      hide = _ref.hide,
      urlContentTeam = _ref.urlContentTeam,
      authorName = _ref.authorName;
  var publishedTime = Date.now();
  var modifiedTime = Date.now();

  if (fullHead) {
    var script = fullHead.match(/<script.*?<\/script>/g);
    var parser = new htmlparser.Parser({
      ontext: function ontext(text) {
        var data = JSON.parse(text)["@graph"].find(function (item) {
          return item["@type"] === "Article";
        });

        if (data !== null && data !== void 0 && data.datePublished) {
          publishedTime = data.datePublished;
        }

        if (data !== null && data !== void 0 && data.dateModified) {
          modifiedTime = data.dateModified;
        }
      }
    });
    parser.write(script);
    parser.end();
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!(hide === 1) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: " mr-6  inline-flex items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiUser, {
        size: 24,
        className: "mr-2 p-0.5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: "font-medium",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: urlContentTeam && urlContentTeam.trim().length > 0 ? urlContentTeam : "/author/bbcincorp-content-team",
          children: authorName && authorName.trim().length > 0 ? authorName : "Content Team"
        })
      })]
    }), !(hide === 2) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mr-6 hidden items-center lg:inline-flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaRegClock, {
        size: 24,
        className: "mr-2 p-0.5"
      }), " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("i", {
        className: "font-medium",
        children: [timeRead ? timeRead : "6 minutes", " read"]
      })]
    }), !(hide === 3) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "inline-flex items-center lg:mr-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiCalendar/* FiCalendar */.v, {
        size: 24,
        className: "mr-2 p-0.5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: "font-medium",
        children: (0,functions/* formatDate */.p)(publishedTime)
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-2 items-center text-center font-medium lg:mt-0 lg:flex lg:text-left",
      children: ["Last Updated on ", (0,functions/* formatDate */.p)(modifiedTime)]
    })]
  });
}

/***/ }),

/***/ 53693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/**
 * Vendor
 */

/**
 * Components
 */




var FormDownload = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9885), __webpack_require__.e(9669), __webpack_require__.e(7445)]).then(__webpack_require__.bind(__webpack_require__, 37445));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37445)];
    },
    modules: ["../components/templates/common/post/FormDownloadModal/index.js -> " + "./FormDownload"]
  }
});

var FormDownloadModal = function FormDownloadModal(_ref) {
  var descriptionClass = _ref.descriptionClass,
      checkboxTextClassName = _ref.checkboxTextClassName,
      show = _ref.show,
      onHide = _ref.onHide,
      typeFormDownload = _ref.typeFormDownload;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FormDownload, {
        descriptionClass: descriptionClass,
        checkboxTextClassName: checkboxTextClassName,
        show: show,
        onHide: onHide,
        typeFormDownload: typeFormDownload
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FormDownloadModal);
/** ========== */

/***/ }),

/***/ 5686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Indicator; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2239);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function Indicator() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(100),
      scroll = _useState[0],
      setScroll = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var progressBarHandler = function progressBarHandler() {
      var totalScroll = document.documentElement.scrollTop;
      var contentHeight = document.getElementById("post-content").scrollHeight;
      var windowHeight = contentHeight - 300;

      if (windowHeight > 2000) {
        // 4500 -> 2000
        var _scroll = "".concat(totalScroll / windowHeight);

        document.getElementById("indicator").classList.add("!block");
        setScroll(_scroll);
      } else {
        document.getElementById("indicator").classList.remove("!block");
        setScroll(0);
      }
    };

    window.addEventListener("scroll", progressBarHandler);
    return function () {
      return window.removeEventListener("scroll", progressBarHandler);
    };
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    id: "indicator",
    className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().indicator)),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "h-1 origin-left scale-0 bg-bbc-brand-500 opacity-100",
      style: {
        transform: "scale(".concat(scroll, ", 1)")
      }
    })
  });
}

/***/ }),

/***/ 2485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainContent; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97464);
/* harmony import */ var components_molecules_SocialShare_SocialShare__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19347);
/* harmony import */ var components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37768);
/* harmony import */ var _FormDownloadModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53693);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41948);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @next/next/no-img-element */







var SsicUK = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(9669), __webpack_require__.e(4837)]).then(__webpack_require__.bind(__webpack_require__, 64837));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64837)];
    },
    modules: ["../components/templates/common/post/MainContent/index.js -> " + "components/templates/common/ssic-code-search/ssic-uk"]
  }
});





function MainContent(_ref) {
  var _data$faqs;

  var data = _ref.data,
      dataJson = _ref.dataJson,
      screen = _ref.screen;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isShow = _useState[0],
      setIsShow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      searchkey = _useState2[0],
      setSearchKey = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showFormDownload = _useState3[0],
      setShowFormDownload = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var iconList = document.querySelectorAll(".fa-check");

    if (iconList) {
      iconList.forEach(function (icon) {
        // eslint-disable-next-line no-param-reassign
        icon.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" className=""></path></svg>';
      });
    }

    var iconSearch = document.querySelectorAll(".fa-search");

    if (iconSearch) {
      iconSearch.forEach(function (icon) {
        // eslint-disable-next-line no-param-reassign
        icon.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>';
      });
    }

    var loadIcon = document.querySelectorAll(".bi-loader");

    if (loadIcon) {
      loadIcon.forEach(function (icon) {
        // eslint-disable-next-line no-param-reassign
        icon.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path></svg>';
      });
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var inputField = document.querySelectorAll(".search_uksic");
    var searchBtn = document.querySelectorAll(".search_btn");

    if (searchBtn[0]) {
      searchBtn[0].addEventListener("click", function () {
        setSearchKey(inputField[0].value);

        if (inputField[0].value === "") {
          setIsShow(false);
        } else {
          setIsShow(true);
        }
      });
    }

    if (inputField[0]) {
      inputField[0].addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
          setSearchKey(inputField[0].value);

          if (inputField[0].value === "") {
            setIsShow(false);
          } else {
            setIsShow(true);
          }
        }
      });
    }

    if (document.getElementById("sic_uk")) {
      react_dom__WEBPACK_IMPORTED_MODULE_2__.render( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
        children: isShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(SsicUK, {
          searchValue: searchkey
        })
      }), document.getElementById("sic_uk"));
    }
  }, [isShow, searchkey]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
    className: (_Index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().postsContent),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: data.content
      }
    }), dataJson && screen !== "DESKTOP" && dataJson.guide_link && dataJson.guide_link.forEach(function (item, index) {
      if (item.chosenPost === data.databaseId) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: "group mt-[30px] rounded-xl  bg-bbc-gradient-liner3 px-3 py-10",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "flex w-full justify-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, item.img), {}, {
              alt: "place-holder"
            }))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
            className: "text-center text-2xl font-semibold text-bbc-white",
            children: item.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
            className: "mt-4 text-center text-bbc-white",
            children: item.description
          }), item.link ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "mt-6 flex w-full justify-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              as: "a",
              href: item.link,
              className: "w-full rounded-full bg-bbc-primary py-2 text-center capitalize  !text-bbc-white",
              target: "_blank",
              children: "Try now"
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: "mt-6 flex w-full justify-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              onClick: function onClick() {
                return setShowFormDownload(true);
              },
              className: "w-full rounded-full bg-bbc-primary py-2 text-center capitalize !text-bbc-white ",
              children: "Unlock guide"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_FormDownloadModal__WEBPACK_IMPORTED_MODULE_8__["default"], {
              typeFormDownload: item.dataForm,
              show: showFormDownload,
              onHide: function onHide() {
                return setShowFormDownload(false);
              }
            })]
          })]
        }, index);
      }
    }), (data === null || data === void 0 ? void 0 : data.faqs) && (data === null || data === void 0 ? void 0 : (_data$faqs = data.faqs) === null || _data$faqs === void 0 ? void 0 : _data$faqs.faqs) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "mt-10 mb-6",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        data: data.faqs.faqs,
        buttonClass: "lg:px-5 font-normal lg:font-medium !text-base lg:!text-lg",
        panelClass: "lg:px-5"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "mt-10 italic",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("p", {
        style: {
          fontSize: "13px",
          lineHeight: "20px"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          className: "font-semibold",
          children: "Disclaimer: "
        }), "While BBCIncorp strives to make the information on this website as timely and accurate as possible, the information itself is for reference purposes only. You should not substitute the information provided in this article for competent legal advice. Feel free to contact BBCIncorp\u2019s customer services for advice on your specific cases."]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_molecules_SocialShare_SocialShare__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      iconWidth: 30,
      iconHeight: 30,
      title: "Share this article",
      titleClass: "block"
    })]
  });
}

/***/ }),

/***/ 21625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RelatedPosts; }
/* harmony export */ });
/* harmony import */ var components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function RelatedPosts(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "mb-10 hidden text-bbc-brand-800 lg:mb-0 lg:block",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: " text-2xl font-semibold leading-9 ",
      children: "Related Posts"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "row mt-6 gap-y-6 lg:mt-8",
      children: data.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "col-12",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
            post: item,
            layout: "horizontal"
          })
        }, index);
      })
    })]
  });
}

/***/ }),

/***/ 19657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ post_RenderTocOrRelated; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/fi/FiChevronsDown.js

function FiChevronsDown(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "7 13 12 18 17 13"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 6 12 11 17 6"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/templates/common/post/RelatedPosts/index.js
var RelatedPosts = __webpack_require__(21625);
// EXTERNAL MODULE: ./common/action-function/scrollToElement.js
var scrollToElement = __webpack_require__(97974);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/common/post/TableOfContents/index.js



function TableOfContents(_ref) {
  var data = _ref.data;

  var renderToc = function renderToc(list, padding, classChild) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      id: "toc-list-table",
      className: padding || "pl-0",
      children: list.map(function (item, index) {
        var _item$children, _item$children2;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: item.hash,
            className: "block w-fit ".concat(classChild || ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0 ? "mb-2" : "mb-4", " hover:text-bbc-brand-600"),
            onClick: function onClick(e) {
              (0,scrollToElement/* default */.Z)(e, true);
            },
            children: item.text.replace(/&amp;/g, "&").replace(/&#8211;/g, "-").replace(/&#8217;/g, "'").replace(/&#8220;/g, "“").replace(/&#8221;/g, "”")
          }), ((_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.length) > 0 && renderToc(item.children, "pl-6 mb-4", "mb-2")]
        }, index);
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "",
    children: renderToc(data)
  });
}
// EXTERNAL MODULE: ./components/templates/common/post/RenderTocOrRelated/Index.module.scss
var Index_module = __webpack_require__(50643);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
;// CONCATENATED MODULE: ./components/templates/common/post/RenderTocOrRelated/index.js
/* eslint-disable no-param-reassign */

/* eslint-disable react-hooks/exhaustive-deps */








var RenderTocOrRelated = function RenderTocOrRelated(_ref) {
  var children = _ref.children,
      post = _ref.post,
      relatedPosts = _ref.relatedPosts;
  var tocRef = (0,react.useRef)();

  var _useState = (0,react.useState)(),
      visited = _useState[0],
      setVisited = _useState[1];

  var _useState2 = (0,react.useState)(false),
      contentLongerThanScreen = _useState2[0],
      setContentLongerThanScreen = _useState2[1];

  var toc = JSON.parse(post.tableOfContents);

  var _useState3 = (0,react.useState)(0),
      y = _useState3[0],
      setY = _useState3[1];

  function isScrolledIntoViewTop(el) {
    if (el) {
      var _ref2 = (el === null || el === void 0 ? void 0 : el.getBoundingClientRect()) || 0,
          top = _ref2.top,
          bottom = _ref2.bottom;

      return top > 80 && top <= window.innerHeight / 2 && bottom <= window.innerHeight;
    }
  }

  function isScrolledIntoViewBottom(el) {
    if (el) {
      var _ref3 = (el === null || el === void 0 ? void 0 : el.getBoundingClientRect()) || 0,
          bottom = _ref3.bottom;

      var space = window.innerHeight - bottom;
      return space > 0 && space < window.innerHeight / 8;
    }
  }

  var checkTocLength = function checkTocLength() {
    if (toc.length > 0) {
      if (toc.length > 2) return true;
      var lengthOfChildren = 0;

      for (var index = 0; index < toc.length; index++) {
        var element = toc[index];

        if (element.children && element.children.length > 0) {
          lengthOfChildren += element.children.length;
        }
      }

      return lengthOfChildren >= 3;
    }

    return false;
  };

  (0,react.useEffect)(function () {
    function getParentNode(element) {
      var _element$parentNode$p;

      return element === null || element === void 0 ? void 0 : (_element$parentNode$p = element.parentNode.parentNode) === null || _element$parentNode$p === void 0 ? void 0 : _element$parentNode$p.parentElement;
    }

    function highlightElement(element) {
      var _element$parentNode$p2;

      element.classList.add("text-bbc-brand-500");

      if ((_element$parentNode$p2 = element.parentNode.parentNode) !== null && _element$parentNode$p2 !== void 0 && _element$parentNode$p2.parentElement) {
        setVisited(getParentNode(element).childNodes[0].hash);
      }
    }

    if (checkTocLength()) {
      window.onscroll = function () {
        // Highlight visited Big Title
        var getTitleList = document.querySelectorAll("#post-content h2");

        var _loop = function _loop(index) {
          var element = getTitleList[index];

          if (isScrolledIntoViewTop(document.getElementById(element.id))) {
            setVisited("#".concat(element.id));
            return "break";
          } else if (isScrolledIntoViewBottom(document.getElementById(element.id))) {
            // Highlight before subtitle on menu on scroll up from big title
            if (index > 0) {
              var _getTitleList;

              setVisited("#".concat((_getTitleList = getTitleList[index - 1]) === null || _getTitleList === void 0 ? void 0 : _getTitleList.id));
              var getTitleListId = document.querySelectorAll("#post-content h2,h3");
              var indexOfVisited = Array.from(getTitleListId).findIndex(function (item) {
                return item.id === getTitleList[index].id;
              });

              if (indexOfVisited) {
                var elementChild = getTitleListId[indexOfVisited - 1];

                if (elementChild.tagName === "H3" && document.querySelector("#toc-desktop a[href='#".concat(elementChild.id, "']"))) {
                  document.querySelector("#toc-desktop a[href='#".concat(elementChild.id, "']")).classList.add("text-bbc-brand-500");
                }
              }
            }
          }
        };

        for (var index = 0; index < getTitleList.length; index++) {
          var _ret = _loop(index);

          if (_ret === "break") break;
        } // Highlight subtitle on menu on scroll


        var getTitleList2 = document.querySelectorAll("#post-content h3");
        getTitleList2.forEach(function (item) {
          if (isScrolledIntoViewTop(document.getElementById(item.id))) {
            var listItemMenu = document.querySelectorAll("#toc-desktop li ul a");

            for (var i = 0; i < listItemMenu.length; i++) {
              var element = listItemMenu[i];
              element.classList.remove("text-bbc-brand-500");

              if (element.hash === "#".concat(item.id)) {
                highlightElement(element);
              }
            }
          } else if (isScrolledIntoViewBottom(document.getElementById(item.id))) {
            // Highlight before subtitle on menu on scroll up
            var _listItemMenu = document.querySelectorAll("#toc-desktop li ul a");

            for (var _i = 0; _i < _listItemMenu.length; _i++) {
              var _element = _listItemMenu[_i];

              if (_element.hash === "#".concat(item.id)) {
                var _getParentNode;

                _element.classList.remove("text-bbc-brand-500");

                if ((_getParentNode = getParentNode(_listItemMenu[_i - 1])) !== null && _getParentNode !== void 0 && _getParentNode.childNodes[0].classList.contains("text-bbc-brand-500")) {
                  _listItemMenu[_i - 1].classList.add("text-bbc-brand-500");
                }
              }
            }
          }
        }); // Collapse TOC if User Scroll on Blog's Content. Expand if user on the top of blog's content

        if (tocRef.current.getBoundingClientRect().top === 178 && tocRef.current.getBoundingClientRect().top > 0) {
          tocRef.current.classList.add((Index_module_default()).collapse);
        } else {
          tocRef.current.classList.remove((Index_module_default()).collapse);
        }

        setY(window.scrollY);
      };
    }
  }, [y, toc]);

  function scrollTo(element, to, duration) {
    var start = element.scrollTop;
    var change = to - start;
    var currentTime = 0;
    var increment = 20;

    var animateScroll = function animateScroll() {
      currentTime += increment;
      var val = Math.easeInOutQuad(currentTime, start, change, duration); // eslint-disable-next-line no-param-reassign

      element.scrollTop = val;

      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };

    animateScroll();
  }

  (0,react.useEffect)(function () {
    // Highlight visited Big Title
    if (visited) {
      var _document$querySelect, _document$querySelect2, _document$querySelect3, _document;

      (_document$querySelect = document.querySelectorAll("#toc-desktop a")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.forEach(function (item) {
        var _item$classList;

        return (_item$classList = item.classList) === null || _item$classList === void 0 ? void 0 : _item$classList.remove("text-bbc-brand-500");
      });
      (_document$querySelect2 = document.querySelector("#toc-desktop a[href='".concat(visited, "']"))) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.classList) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.add("text-bbc-brand-500");

      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t -= 1;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      var el = document.getElementById("toc-desktop");
      var targetElm = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector("#toc-desktop a[href='".concat(visited, "']"));
      var topPos = targetElm === null || targetElm === void 0 ? void 0 : targetElm.offsetTop;
      scrollTo(el, topPos - 90, 300);
    }
  }, [visited]);
  (0,react.useEffect)(function () {
    function renderTocOnResizeScreen() {
      if (document.getElementById("toc-list-table").offsetHeight > window.innerHeight * 0.8) {
        setContentLongerThanScreen(true);
      } else {
        setContentLongerThanScreen(false);
      }
    }

    if (checkTocLength()) {
      renderTocOnResizeScreen();
    }

    window.addEventListener("resize", renderTocOnResizeScreen);
    return window.removeEventListener("resize", renderTocOnResizeScreen);
  }, [toc]);

  if (checkTocLength()) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "sticky top-32 mb-10 text-bbc-brand-800 lg:mb-0 ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((Index_module_default()).toc, " group rounded-xl  px-4 hover:cursor-pointer lg:bg-white lg:py-2"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "flex items-center justify-between py-2 font-medium group-hover:text-bbc-brand-500",
          children: ["Table of Contents", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronsDown, {
            className: "float-right hidden align-middle lg:inline-block "
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: tocRef,
          id: "toc-desktop",
          className: "".concat((Index_module_default()).tocDesk, " hidden ").concat(contentLongerThanScreen ? "overflow-y-auto" : "overflow-hidden", " scroll-smooth pr-8 transition-all duration-300 lg:block"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableOfContents, {
            data: toc
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "block lg:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableOfContents, {
            data: toc
          })
        })]
      }), children]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-8 text-bbc-brand-800 lg:mb-0 ",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RelatedPosts/* default */.Z, {
        data: relatedPosts
      })
    }), children]
  });
};

/* harmony default export */ var post_RenderTocOrRelated = (RenderTocOrRelated);

/***/ }),

/***/ 81449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(40037);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1216);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var common_hooks_usePauseBrowserScroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99954);
/* harmony import */ var common_hooks_useResizeScreenModified__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77450);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_GoToTop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15068);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85882);
/* harmony import */ var components_molecules_Breadcrumb__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49011);
/* harmony import */ var components_molecules_FormNewsletter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32314);
/* harmony import */ var components_molecules_SocialShare_SocialShare__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19347);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47447);
/* harmony import */ var components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37768);
/* harmony import */ var _RenderTocOrRelated_index__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(19657);
/* harmony import */ var _AuthorAndTime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(53807);
/* harmony import */ var _Indicator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5686);
/* harmony import */ var _MainContent__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2485);
/* harmony import */ var _MainContent_Index_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41948);
/* harmony import */ var _MainContent_Index_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_MainContent_Index_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-inner-declarations */

/* eslint-disable no-param-reassign */























var NewsSlider = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8352), __webpack_require__.e(9485)]).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/common/post/index.js -> " + "components/organisms/NewsSlider"]
  }
});
var EbookModal = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function () {
  return __webpack_require__.e(/* import() */ 9047).then(__webpack_require__.bind(__webpack_require__, 99047));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(99047)];
    },
    modules: ["../components/templates/common/post/index.js -> " + "components/molecules/EbookModal"]
  }
});
var FormDownloadModal = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53693));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(53693)];
    },
    modules: ["../components/templates/common/post/index.js -> " + "./FormDownloadModal"]
  }
});
var PostModal = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function () {
  return __webpack_require__.e(/* import() */ 1517).then(__webpack_require__.bind(__webpack_require__, 21517));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(21517)];
    },
    modules: ["../components/templates/common/post/index.js -> " + "./PostModal"]
  }
});
var Whitepaper = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9973), __webpack_require__.e(9669), __webpack_require__.e(4455)]).then(__webpack_require__.bind(__webpack_require__, 94455));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94455)];
    },
    modules: ["../components/templates/common/post/index.js -> " + "./WhitepaperModal"]
  }
});

var getReadingTime = function getReadingTime(str) {
  var words = str.replace(/<[^>]+>/g, "").split(" ").length;
  var readTime = Math.floor(words / 250);

  if (readTime <= 1) {
    return "1 minute";
  }

  return "".concat(readTime, " minutes");
};

var checkDataFormId = function checkDataFormId(id) {
  if (id === "ebook-shortcode-offshore") {
    return {
      form_id: 21,
      country: "Offshore Company"
    };
  }

  if (id === "ebook-shortcode-delaware") {
    return {
      form_id: 24,
      country: "Delaware"
    };
  }

  if (id === "ebook-shortcode") {
    return {
      form_id: 20,
      country: "Hong Kong"
    };
  }

  if (id === "ebook-shortcode-singapore") {
    return {
      form_id: 26,
      country: "Singapore"
    };
  }

  return {
    form_id: "",
    country: ""
  };
};

var dataID = "";

var PostTemplate = function PostTemplate(_ref) {
  var _post$content, _data$page, _data$page2, _post$featuredImage, _post$faqs, _post$parts3, _post$parts3$parts;

  var data = _ref.data,
      dataJson = _ref.dataJson,
      specialLayout = _ref.specialLayout,
      haveEbook = _ref.haveEbook,
      hiddenFeatureImg = _ref.hiddenFeatureImg;
  var post = data.post,
      recentPosts = data.recentPosts,
      relatedPosts = data.relatedPosts;
  var getIframe = post.content.match(/<iframe .*?<\/iframe>/g) || "";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((getIframe === null || getIframe === void 0 ? void 0 : getIframe.length) > 0 && ((_post$content = post.content) === null || _post$content === void 0 ? void 0 : _post$content.split(getIframe[0])) || post),
      contentAfterSplit = _useState[0];

  var readingTime = getReadingTime(post === null || post === void 0 ? void 0 : post.content);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      modalShow = _useState2[0],
      setModalShow = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      ebookShow = _useState3[0],
      setEbookShow = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showFormDownload = _useState4[0],
      setShowFormDownload = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      haveFormDownload = _useState5[0],
      setHaveFormDownload = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("checklist_hk"),
      typeFormDownload = _useState6[0],
      setTypeFormDownload = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      haveWhitepaper = _useState7[0],
      setHaveWhitepaper = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      whitepaperShow = _useState8[0],
      setWhitepaperShow = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      tableSlideCount = _useState9[0];

  var category = post.categories.nodes.find(function (item) {
    return item.parent === null;
  }) || "";
  var country = (category === null || category === void 0 ? void 0 : category.name.toLowerCase()) === "articles" && post.categories.nodes.find(function (item) {
    return item.parent !== null;
  }) || "";

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      screen = _useState10[0],
      setScreen = _useState10[1];

  (0,common_hooks_useResizeScreenModified__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(setScreen);
  (0,common_hooks_usePauseBrowserScroll__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (document.getElementsByClassName("shortcode_download_form").length > 0) {
      setHaveFormDownload(true);
      document.querySelectorAll(".shortcode_download_form.btn").forEach(function (item) {
        item.addEventListener("click", function (e) {
          setTypeFormDownload(e.target.dataset.typeShortcode);
          setShowFormDownload(true);
        });
      });
    }

    if (document.querySelectorAll("#whitepaper-shortcode .btn").length > 0) {
      setHaveWhitepaper(true);
      document.querySelectorAll("#whitepaper-shortcode .btn").forEach(function (item) {
        item.addEventListener("click", function () {
          setWhitepaperShow(true);
        });
      });
    }
  }, [modalShow]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    document.querySelectorAll('#ez-toc-container a[href^="#"]').forEach(function (anchor) {
      // eslint-disable-next-line func-names, space-before-function-paren
      anchor.addEventListener("click", function (event) {
        event.preventDefault(); // eslint-disable-next-line no-invalid-this

        var hash = this.getAttribute("href").split("#").filter(function (item) {
          return item;
        }).join("");
        var el = document.getElementById(hash);
        window.scrollTo({
          left: 0,
          top: el.getBoundingClientRect().top + window.pageYOffset - 90,
          behavior: "smooth"
        });

        if (window.history.pushState) {
          window.history.pushState(null, null, "#".concat(hash));
        }
      });
    }); // Radio handle click

    var radiosList = document.getElementsByName("checkLink");
    var checkList = document.getElementsByClassName("check-option");
    var btnGetStarted = document.getElementById("btn-get-started");

    if (radiosList && radiosList.length > 0) {
      radiosList.forEach(function (radio, radioIdx) {
        if (radioIdx === 0) {
          radio.checked = true;
        }

        function checkRadio() {
          radio.checked = true;
          btnGetStarted.href = radio.value;
        }

        radio.addEventListener("change", checkRadio);
        checkList[radioIdx].addEventListener("click", checkRadio);
      });
    } // Table handle


    var tableList = document.getElementsByTagName("table");

    if (tableList) {
      var tableWithRowSpan = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(tableList).filter(function (item) {
        return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(item.rows).filter(function (element) {
          return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(element.cells).filter(function (i) {
            return i.rowSpan > 1;
          }).length > 0 && element.parentElement.nodeName === "TBODY";
        }).length > 0;
      });

      var tableNotHead = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(tableList).filter(function (item) {
        return item.firstElementChild.nodeName === "TBODY";
      });

      if (tableWithRowSpan.length > 0) {
        tableWithRowSpan.map(function (item) {
          return item.classList.add("table-rowspan");
        });
      }

      if (tableNotHead.length > 0) {
        tableNotHead.map(function (item) {
          return item.classList.add("table-notheader");
        });
      }
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var tableWithButtonNext = document.getElementsByClassName("table-with-arrow");

    (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(tableWithButtonNext).map(function (item, index) {
      return item.id = "test-".concat(index);
    });

    var _loop = function _loop(i) {
      var table = document.getElementById("test-".concat(i));

      function nextColumn(value) {
        (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(table.rows).map(function (item) {
          return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(item.cells).map(function (e, index) {
            return index === value - 1 ? e.style.display = "none" : null;
          });
        });

        (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(table.rows).map(function (item) {
          return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(item.cells).map(function (e, index) {
            return index === value ? e.style.display = "table-cell" : null;
          });
        });
      }

      function prevColumn(value) {
        (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(table.rows).map(function (item) {
          return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(item.cells).map(function (e, index) {
            return index === value + 1 ? e.style.display = "none" : null;
          });
        });

        (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(table.rows).map(function (item) {
          return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(item.cells).map(function (e, index) {
            return index === value ? e.style.display = "table-cell" : null;
          });
        });
      }

      (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(table.rows[0].cells).forEach(function (item, index) {
        // Button Next
        var buttonNext = document.createElement("button");
        buttonNext.className = "button-next-arrow block lg:hidden";
        buttonNext.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" color="#fff" style="color:#fff" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>';
        buttonNext.addEventListener("click", function () {
          return nextColumn(index + 1);
        }); // Button Prev

        var buttonPrev = document.createElement("button");
        buttonPrev.className = "button-prev-arrow block lg:hidden";
        buttonPrev.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" color="#fff" style="color:#fff" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>';
        buttonPrev.addEventListener("click", function () {
          return prevColumn(index - 1);
        });

        if (index > 0) {
          if (index == 1) {
            item.appendChild(buttonNext);
          } else if (index == table.rows[0].cells.length - 1) {
            item.appendChild(buttonPrev);
          } else {
            item.appendChild(buttonNext);
            item.appendChild(buttonPrev);
          }

          item.id = "test-".concat(i, "-").concat(index);
        }
      });
    };

    for (var i = 0; i < tableWithButtonNext.length; i++) {
      _loop(i);
    }
  }, [tableSlideCount]);

  var renderToc = function renderToc() {
    var _post$parts, _post$parts$parts, _post$parts2;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)(_RenderTocOrRelated_index__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
      post: post,
      dataJson: dataJson,
      haveEbook: haveEbook,
      relatedPosts: (post === null || post === void 0 ? void 0 : (_post$parts = post.parts) === null || _post$parts === void 0 ? void 0 : (_post$parts$parts = _post$parts.parts) === null || _post$parts$parts === void 0 ? void 0 : _post$parts$parts.length) > 0 ? post === null || post === void 0 ? void 0 : (_post$parts2 = post.parts) === null || _post$parts2 === void 0 ? void 0 : _post$parts2.parts : relatedPosts,
      children: [dataJson && screen === "DESKTOP" && dataJson.guide_link && dataJson.guide_link.forEach(function (item, index) {
        if (item.chosenPost === post.databaseId) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
            className: "group mt-[30px] rounded-xl  bg-bbc-gradient-liner3 px-3 py-10",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, item.img), {}, {
              alt: "place-holder"
            })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
              className: "text-center text-2xl font-semibold text-bbc-white",
              children: item.title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
              className: "mt-4 text-center text-bbc-white",
              children: item.description
            }), item.link ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
              className: "mt-6 flex w-full justify-center",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                as: "a",
                href: item.link,
                className: "w-full rounded-full bg-bbc-primary py-2 text-center capitalize text-bbc-white hover:bg-bbc-white hover:text-bbc-primary",
                target: "_blank",
                children: "Try now"
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
              className: "mt-6 flex w-full justify-center",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                onClick: function onClick() {
                  return setShowFormDownload(true);
                },
                className: "w-full rounded-full bg-bbc-primary py-2 text-center capitalize text-bbc-white hover:bg-bbc-white hover:text-bbc-primary",
                children: "Unlock guide"
              }), showFormDownload && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(FormDownloadModal, {
                typeFormDownload: item.dataForm,
                show: showFormDownload,
                onHide: function onHide() {
                  return setShowFormDownload(false);
                }
              })]
            })]
          }, index);
        }
      }), haveEbook && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
        className: "hidden lg:block",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
          className: "mt-10 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h4", {
            className: "mb-3 font-semibold",
            children: "Don't miss out on this guide"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              src: "/assets/images/common/offshore-ebook.png",
              width: 762,
              height: 1000,
              alt: "ebook"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("button", {
            className: "group relative mt-3 h-10 rounded border-0 bg-bbc-brand-500 px-10 py-2 font-bold text-white\n                      before:absolute before:right-0 before:top-0 before:h-0 before:w-0.5 before:bg-bbc-brand-500 before:transition-all before:duration-500 before:ease-in-out before:content-['']\n                      after:absolute after:right-0 after:top-0 after:h-0.5 after:w-0 after:bg-bbc-brand-500 after:transition-all after:duration-500 after:ease-in-out after:content-['']\n                     \n                      hover:bg-white hover:text-bbc-brand-500 hover:before:h-full hover:after:w-full ",
            onClick: function onClick() {
              return setEbookShow(true);
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
              className: "before:absolute before:left-0 before:bottom-0 before:h-0 before:w-0.5 before:bg-bbc-brand-500 before:transition-all before:duration-300 before:ease-in-out before:content-['']\n                      after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-0 after:bg-bbc-brand-500 after:transition-all after:duration-300 after:ease-in-out after:content-['']\n                     group-hover:before:h-full group-hover:after:w-full",
              children: "Download Now"
            })
          })]
        }), ebookShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(EbookModal, {
            show: ebookShow,
            onHide: function onHide() {
              return setEbookShow(false);
            },
            apiLink: "api/portal/contact_form/profile_request",
            haveCheckBox: true,
            checkedId: 21,
            unCheckId: 23,
            imgLeft: "/assets/images/common/offshore-ebook.png",
            imgWidth: 762,
            imgHeight: 1000,
            triggerName: "Ebook - Offshore Company"
          })
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_GoToTop__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_Indicator__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("section", {
      id: "banner",
      children: specialLayout ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        minHeightBanner: "".concat(dataJson && dataJson.special_layout && dataJson.special_layout.some(function (el) {
          return el.chosenPost == post.databaseId;
        }) ? "banner-min-h-503" : "banner-min-h-635", " "),
        title: post.title,
        bgColor: "bg-bbc-gradient-service",
        breadcrumbs: [{
          title: (category === null || category === void 0 ? void 0 : category.name) || "",
          uri: (category === null || category === void 0 ? void 0 : category.uri) || ""
        }, Object.keys(country).length > 0 && {
          title: country === null || country === void 0 ? void 0 : country.name,
          uri: country === null || country === void 0 ? void 0 : country.uri
        }, {
          title: post.title,
          uri: post.uri
        }].filter(function (item) {
          return item;
        }),
        leftClassName: "relative lg:mt-0 col-12 lg:col-6",
        rightClassName: "col-12 lg:col-6",
        description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            className: "mb-6 text-center text-sm leading-6 lg:mb-10 lg:text-left",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_AuthorAndTime__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              timeRead: readingTime,
              fullHead: data === null || data === void 0 ? void 0 : (_data$page = data.page) === null || _data$page === void 0 ? void 0 : _data$page.head
            })
          })
        }),
        rightContent: dataJson && dataJson.special_layout && dataJson.special_layout.some(function (el) {
          return el.chosenPost == post.databaseId;
        }) ? dataJson.special_layout.forEach(function (item, index) {
          if (item.chosenPost == post.databaseId) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              className: "m-auto lg:w-full",
              src: item.imgSrc,
              width: item.width,
              height: item.height,
              alt: item.imgAlt,
              priority: true,
              wrapper: {
                className: "bbc-banner-image-bottom-0"
              }
            }, index);
          }
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          className: "m-auto lg:w-full",
          src: "/assets/images/common/special-blog-banner.png",
          width: 562,
          height: 436,
          alt: "banner",
          priority: true,
          wrapper: {
            className: "bbc-banner-image-bottom-0"
          }
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
          className: "pt-28  lg:pt-[198px]",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_molecules_Breadcrumb__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            items: [{
              title: (category === null || category === void 0 ? void 0 : category.name) || "",
              uri: (category === null || category === void 0 ? void 0 : category.uri) || ""
            }, Object.keys(country).length > 0 && {
              title: country === null || country === void 0 ? void 0 : country.name,
              uri: country === null || country === void 0 ? void 0 : country.uri
            }, {
              title: post.title,
              uri: post.uri
            }].filter(function (item) {
              return item;
            }),
            className: "mb-6 lg:mb-8"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            as: "h1",
            className: "banner-title-default-color banner-default-title mb-6 lg:mb-10",
            children: post.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            className: " min-h-[64px] border-black text-center text-sm lg:flex lg:border-b lg:pb-10 lg:text-left ",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_AuthorAndTime__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              timeRead: readingTime,
              fullHead: data === null || data === void 0 ? void 0 : (_data$page2 = data.page) === null || _data$page2 === void 0 ? void 0 : _data$page2.head
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
          className: "row",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
            className: "lg:col-8",
            id: "post-content",
            children: [!hiddenFeatureImg && screen !== "TABLET" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              image: (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
              alt: post.title,
              className: " w-full ",
              wrapper: {
                className: "hidden md:block w-full h-auto mb-10",
                style: {
                  maxHeight: "626px"
                }
              },
              priority: true
            }), screen !== "DESKTOP" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
              children: renderToc()
            }), getIframe.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
              className: (_MainContent_Index_module_scss__WEBPACK_IMPORTED_MODULE_22___default().postsContent),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: contentAfterSplit[0]
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                classNamePrefix: "lazy-load-custom",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                  dangerouslySetInnerHTML: {
                    __html: getIframe[0]
                  }
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: contentAfterSplit[1]
                }
              }), dataJson && screen !== "DESKTOP" && dataJson.guide_link && dataJson.guide_link.forEach(function (item, index) {
                if (item.chosenPost === post.title) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                    className: "group mt-[30px] overflow-y-scroll  rounded-xl bg-bbc-gradient-liner3 px-3 py-10",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                      src: item.imgSrc,
                      alt: "place-holder"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                      className: "text-center text-2xl font-semibold text-bbc-white",
                      children: item.title
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                      className: "mt-4 text-center text-bbc-white",
                      children: item.description
                    }), item.link ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                      className: "mt-6 flex w-full justify-center",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        as: "a",
                        href: item.link,
                        className: "w-full rounded-full bg-bbc-primary py-2 text-center capitalize !text-bbc-white",
                        target: "_blank",
                        children: "Try now"
                      })
                    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                      className: "mt-6 flex w-full justify-center",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        onClick: function onClick() {
                          return setShowFormDownload(true);
                        },
                        className: "w-full rounded-full bg-bbc-primary py-2 text-center capitalize !text-bbc-white",
                        children: "Unlock guide"
                      }), showFormDownload && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(FormDownloadModal, {
                        typeFormDownload: item.dataForm,
                        show: showFormDownload,
                        onHide: function onHide() {
                          return setShowFormDownload(false);
                        }
                      })]
                    })]
                  }, index);
                }
              }), (post === null || post === void 0 ? void 0 : post.faqs) && (post === null || post === void 0 ? void 0 : (_post$faqs = post.faqs) === null || _post$faqs === void 0 ? void 0 : _post$faqs.faqs) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                className: "mt-10 mb-6",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                  data: post.faqs.faqs,
                  buttonClass: "lg:px-5 font-normal lg:font-medium !text-base lg:!text-lg",
                  panelClass: "lg:px-5"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                className: "mt-10",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("p", {
                  style: {
                    fontSize: "13px",
                    lineHeight: "20px"
                  },
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                    className: "font-semibold",
                    children: "Disclaimer: "
                  }), "While BBCIncorp strives to make the information on this website as timely and accurate as possible, the information itself is for reference purposes only. You should not substitute the information provided in this article for competent legal advice. Feel free to contact BBCIncorp\u2019s customer services for advice on your specific cases."]
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_molecules_SocialShare_SocialShare__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                iconWidth: 30,
                iconHeight: 30,
                title: "Share this article",
                titleClassName: "block"
              })]
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_MainContent__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                data: post,
                dataJson: dataJson,
                screen: screen
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            className: "hidden lg:col-4 lg:block",
            children: renderToc()
          })]
        })
      })
    }), recentPosts.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("section", {
      className: "mb-10 lg:mb-20",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(NewsSlider, {
            data: {
              posts: (post === null || post === void 0 ? void 0 : (_post$parts3 = post.parts) === null || _post$parts3 === void 0 ? void 0 : (_post$parts3$parts = _post$parts3.parts) === null || _post$parts3$parts === void 0 ? void 0 : _post$parts3$parts.length) > 0 ? post.parts.parts : recentPosts
            }
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_molecules_FormNewsletter__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
      className: "hidden lg:col-8"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
      className: "hidden lg:col-5"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
      className: "hidden lg:col-4"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
      className: "hidden lg:col-6"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
      className: "hidden lg:col-7"
    }), dataID.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: modalShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(PostModal, {
        show: modalShow,
        ebookdata: checkDataFormId(dataID),
        onHide: function onHide() {
          return setModalShow(false);
        }
      })
    }), haveWhitepaper && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: whitepaperShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(Whitepaper, {
        show: whitepaperShow,
        onHide: function onHide() {
          return setWhitepaperShow(false);
        }
      })
    }), haveFormDownload && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(FormDownloadModal, {
      typeFormDownload: typeFormDownload,
      show: showFormDownload,
      onHide: function onHide() {
        return setShowFormDownload(false);
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PostTemplate);

/***/ }),

/***/ 2239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Index_indicator__7QrvS"};

/***/ }),

/***/ 41948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postsContent":"Index_postsContent__WTYz0","t-head1":"Index_t-head1__FS_GD","t-head2":"Index_t-head2__L0vRl"};

/***/ }),

/***/ 50643:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toc":"Index_toc__wPljj","tocDesk":"Index_tocDesk__skWGr","collapse":"Index_collapse__oIbbM"};

/***/ })

}]);